/**
 * InvoiceForm – inline styles + warning banner sub-components
 *
 * Extracted from InvoiceForm.tsx so the main JSX file stays under the
 * max-lines-per-function limits.
 */

import type { JSX } from 'react'

export function PostedInvoiceWarningBanner(): JSX.Element {
  return (
    <div className="card el-p-md bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800 flex items-start gap-3">
      <svg
        className="w-5 h-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
      <div>
        <p className="font-medium text-amber-800 dark:text-amber-200 text-sm">
          Editing a posted invoice
        </p>
        <p className="text-amber-700 dark:text-amber-300 text-xs mt-0.5">
          The existing journal entry will be removed and a new one created. Party details cannot be
          changed.
        </p>
      </div>
    </div>
  )
}

const INVOICE_FORM_STYLES = `
  .form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }

  .totals-section {
    background: hsl(var(--surface-sunken)) !important;
    border-color: hsl(var(--border)) !important;
  }

  .totals-grid {
    max-width: 550px;
    margin-left: auto;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    border-bottom: 1px solid hsl(var(--border));
    font-size: 13px;
  }

  .total-row span:first-child {
    color: hsl(var(--foreground-secondary));
  }

  .total-row .amount {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
    color: hsl(var(--foreground));
  }

  .total-final {
    border-bottom: none;
    padding-top: 6px;
    margin-top: 6px;
    border-top: 2px solid hsl(var(--primary));
    font-size: 14px;
  }

  .total-final span {
    color: hsl(var(--foreground));
    font-weight: 600;
  }

  .total-final .amount {
    color: hsl(var(--foreground));
    font-weight: 700;
    font-size: 15px;
  }

  .compact-table th {
    padding: 8px 6px !important;
    line-height: 1.4;
  }

  .compact-table td {
    padding: 8px 4px !important;
    vertical-align: middle;
  }

  .compact-table input,
  .compact-table select {
    line-height: 1.4;
  }

  .compact-table button[title="Remove item"] {
    padding: 4px 8px !important;
    min-width: 28px;
    height: 28px;
    line-height: 1;
  }
`

export function FormStyles(): JSX.Element {
  return <style>{INVOICE_FORM_STYLES}</style>
}
